/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Rest_Api_S3_Li4Inputs */

const en_guide_json_rest_api_s3_li4 = /** @type {(inputs: Guide_Json_Rest_Api_S3_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>Envelope pattern</strong>: <code>&#123;"status": "success", "data": &#123;...&#125;&#125;</code> includes status`)
};

const ko_guide_json_rest_api_s3_li4 = /** @type {(inputs: Guide_Json_Rest_Api_S3_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>엔벨로프 패턴</strong>: <code>&#123;"status": "success", "data": &#123;...&#125;&#125;</code>에 상태 포함`)
};

const ja_guide_json_rest_api_s3_li4 = /** @type {(inputs: Guide_Json_Rest_Api_S3_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>エンベロープパターン</strong>: <code>&#123;"status": "success", "data": &#123;...&#125;&#125;</code>にステータスを含む`)
};

/**
* | output |
* | --- |
* | "<strong>Envelope pattern</strong>: <code>&#123;\"status\": \"success\", \"data\": &#123;...&#125;&#125;</code> includes status" |
*
* @param {Guide_Json_Rest_Api_S3_Li4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_rest_api_s3_li4 = /** @type {((inputs?: Guide_Json_Rest_Api_S3_Li4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Rest_Api_S3_Li4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_rest_api_s3_li4(inputs)
	if (locale === "ko") return ko_guide_json_rest_api_s3_li4(inputs)
	return ja_guide_json_rest_api_s3_li4(inputs)
});